import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

/**
 * Generated class for the FormatMinExperiencePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatMinExperience',
})
export class FormatMinExperiencePipe implements PipeTransform {
  /**
   * Takes a job's experience value and returns in human readable format
   */
  transform(v: any, ...args) {
    let value;
    if (typeof v === 'string') {
      value = [v];
    } else {
      value = v || [];
    }

    let experience = {
        needtraining: 'Need CDL Training',
        intraining: 'In CDL School Now',
        graduatedtraining: 'CDL Grad, No Experience Yet',
        '1-5_months': '1-5 Months',
        '6-11_months': '6-11 Months',
        '12-23_months': '12-23 Months',
        '2_years': '2 Years',
        '3_years': '3 Years',
        '4_years': '4 Years',
        '5+_years': '5+ Years',
      },
      experienceTypes = _.keys(experience);

    if (!_.size(value)) return 'No Requirement Specified';

    return (
      _.filter(experienceTypes, v => {
        return _.includes(value, v);
      })
        .map(v => {
          return experience[v];
        })
        .join(' • ') || 'No Requirement Specified'
    );
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-min-experience/format-min-experience.ts